import React from 'react';
import CommissionHistory from '../../components/Franchise/CommisionHistory';

export default function CommisionHistoryPage() {
	return <CommissionHistory />;
}
